module.exports = __webpack_public_path__ + "static/media/2019-09-22.15420c11.md";